{
    "KbLrzffmJSwxZnDeU5E27": {
        "key": "KbLrzffmJSwxZnDeU5E27",
        "position": {
            "x": 2,
            "y": 8,
            "z": 1
        }
    },
    "vCIwgxm-lpcpX-Egjv1Va": {
        "key": "vCIwgxm-lpcpX-Egjv1Va",
        "position": {
            "x": 1,
            "y": 8,
            "z": 1
        }
    },
    "5qRdum11uD1lHgUdq-DAX": {
        "key": "5qRdum11uD1lHgUdq-DAX",
        "position": {
            "x": 0,
            "y": 8,
            "z": 1
        }
    }
}